import React from "react";
import { Button } from "primereact/button";
// import { useNavigate } from 'react-router-dom';
import styled from "./Index.module.css";
import logo from "../../assets/img/replyWide.png";
import { useTranslation } from 'react-i18next';

const NotFound: React.FC = () => { 
  const { t: translate } = useTranslation("404");

  return (
    <div className={`${styled.content} `}>
      <img src={logo} alt="" />
      <h1 className={`${styled.header_tittle} `}>{translate("SorryMessage")}!</h1>
      <p className={styled.text}>{translate("Message")}</p>
      <Button
        className={`${styled.button} `}
        onClick={() => window.history.back()}
      >
         {translate("GoBack")}
      </Button>
    </div>
  );
};

export default NotFound;
